<template>
  <div class="con-wrap">
    <div class="fl" style="width: 100%">
      <div class="select-wrap fl">
        <span>分部：</span>
        <el-select v-model="area" class="w200" @change="initcategory">
          <el-option v-for="item in area_list" :key="item.id" :value="item.id" :label="item.divisionName"></el-option>
        </el-select>
      </div>
      <div class="select-wrap fl">
        <span>报警分类：</span>
        <el-select v-model="category" class="w200" @change="initDevice">
          <el-option v-for="item in category_list" :key="item.acid" :value="item.acid" :label="item.alarmCategoryName"></el-option>
        </el-select>
      </div>
      <div class="select-wrap fl">
        <span>设备类型：</span>
        <el-select v-model="device_type" class="w200">
          <el-option v-for="item in device_type_list" :key="item.deviceNumberSegment" :value="item.deviceNumberSegment" :label="item.deviceTypeName"></el-option>
        </el-select>
      </div>
      <div class="select-wrap fl">
      <span>设备名称：</span>
      <el-input type="text" class="input-box input-cell" v-model="device_num"></el-input>
    </div>
      <div class="select-wrap fl">
        <span>处理状态：</span>
        <el-select v-model="status" class="w200">
          <el-option v-for="item in status_list" :label="item.name" :key="item.id" :value="item.id">{{item.name}}</el-option>
        </el-select>
      </div>
    </div>
    <div class="fl">
      <div class="select-wrap fl">
        <span>报警时间：</span>
        <el-date-picker
          class="w150"
          v-model="date_from"
          type="date"
          :picker-options="default_sdate"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="选择起始时间">
        </el-date-picker>
         ——
        <el-date-picker
          class="w150"
          v-model="date_end"
          type="date"
          format="yyyy-MM-dd"
          :picker-options="default_edate"
          value-format="yyyy-MM-dd"
          placeholder="选择结束时间"></el-date-picker>
      </div>
      <div class="select-wrap fl">
      <el-button @click="query(1)">查询</el-button>
    </div>
    </div>
    <div class="download-wrap fr">
      <el-button @click="download">下载</el-button>
      <el-button @click="print">打印</el-button>
<!--      <el-button @click="printTable({title:(area_list.find(item => item.id === area).divisionName=='全部'?'全部分部':area_list.find(item => item.id === area).divisionName)+'-'+(category_list.find(item =>item.acid === category).alarmCategoryName=='全部'?'全部报警':category_list.find(item =>item.acid === category).alarmCategoryName)+'-'+(device_type_list.find(item =>item.deviceNumberSegment === device_type).deviceTypeName=='全部'?'全部设备':device_type_list.find(item =>item.deviceNumberSegment === device_type).deviceTypeName)+(device_num?'-'+device_num:'')+'-'+(status_list.find(item => item.id===status).name=='全部'?'所有报警':status_list.find(item => item.id===status).name),selector:'#table-box'})">打印</el-button>-->
    </div>
    <div class="table-wrap" >
      <el-table id="table-box" :data="table_date" class="h50" width="98%" border>
        <el-table-column label="选择" width="50">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.select"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="ID" prop="id" ></el-table-column>
        <el-table-column label="报警等级" prop="alarmLevel" >
          <template slot-scope="scope">
            <span :class="['alarm-level',scope.row.alarmLevel=='1'?'first-lv':(scope.row.alarmLevel=='2'?'second-lv':'')]">{{scope.row.alarmLevel}}</span>
          </template>
        </el-table-column>
        <el-table-column label="报警分类" prop="alarmCategoryName" ></el-table-column>
        <el-table-column label="分部" prop="divisionName" ></el-table-column>
        <el-table-column label="设备名称" prop="deviceRealName" ></el-table-column>
        <el-table-column label="设备类型" prop="deviceTypeName" ></el-table-column>
        <el-table-column label="报警描述" prop="alarmDescription" ></el-table-column>
        <el-table-column label="报警图像" prop="alarmImageUri" >
          <template slot-scope="scope">
            <img v-if="scope.row.alarmImageUri" :src="rootUrl + scope.row.alarmImageUri" alt="" width="100%" @click="enlargeImg(scope)" style="cursor: pointer">
          </template>
        </el-table-column>
        <el-table-column label="报警时间" prop="createdAt" ></el-table-column>
        <el-table-column label="报警值" prop="alarmValue"></el-table-column>
        <el-table-column label="正常值" prop="alarmThreshold" ></el-table-column>
        <el-table-column label="处理状态" prop="isDeal" >
          <template slot-scope="scope">
            <span v-if="scope.row.isDeal == '0'">未处理</span>
            <span v-else>已处理</span>
          </template>
        </el-table-column>
        <el-table-column label="处理人" prop="nickName"></el-table-column>
        <el-table-column label="处理时间" prop="confirm_time"></el-table-column>
        <el-table-column label="操作" prop="name" class="handles" min-width="250">
          <template slot-scope="scope">
            <el-button class="w70" @click="handleAlarm(scope)">处理</el-button>
            <el-button class="w70" @click="checkAlarm(scope.row.id)">查看</el-button>
            <el-button class="w70" @click="deleteAlarm(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="all-select-box">
        <el-button @click="selectAll">全选</el-button>
        <el-button @click="selectNone">全清</el-button>
        <el-button class="fr" @click="deleteAlarm()">批量删除</el-button>
        <el-button class="fr" @click="handleAlarm()">批量处理</el-button>
      </div>
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :page-size='page_size'
        :current-page.sync="current_page"
        layout="total,prev,pager,next,jumper"
        :total="total"></el-pagination>
    </div>
    <el-dialog
      title="处理"
      :visible.sync="checkVisible"
      width="33%">
      <el-table
        :data="check_data"
        border>
        <el-table-column label="处理内容" prop="deal_msg"></el-table-column>
        <el-table-column width="200" label="处理人" prop="operator_name"></el-table-column>
        <el-table-column width="200" label="处理时间" prop="deal_at"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="checkVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="查看图片"
      :visible.sync="imgVisible"
      width="22%">
      <img :src="imgSrc" alt="">
      <span slot="footer" class="dialog-footer">
        <el-button @click="imgVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {setSession} from "../../assets/js/tools/instruments";

  export default {
  name: "alarmManagement",
  data(){
    return{
      category: '0',
      category_list: [],
      area: '0',
      area_list: [],
      device_type: '0',
      device_type_list: [],
      device_num: '',
      date_from: '',
      date_end: '',
      default_sdate:{
        disabledDate:(time)=>{
          if(this.date_end){
            return time.getTime() > new Date(this.date_end).getTime()
          }else{
            return time.getTime() >new Date().getTime()
          }
        }
      },
      default_edate:{
        disabledDate:(time)=>{
          return time.getTime() < new Date(this.date_from).getTime() || time.getTime()>new Date().getTime()
        }
      },
      status: '2',
      status_list: [
        {
          id: '2',
          name: '全部'
        },
        {
          id: 0,
          name: '未处理'
        },
        {
          id: 1,
          name: '已处理'
        }
      ],
      table_date: [],
      total: 100,
      page_size: 10,
      current_page: 1,
      init_flag: true,
      handleVisible: false,
      handle_note: '',
      handle_id: '',
      check_data: [],
      checkVisible: false,
      data_flag: true,
      imgVisible: false,
      imgSrc: '',
      currentPage: 1,
    }
  },
  mounted() {
    this.initSelectData();
    this.initTableData()
  },
  methods:{
    initSelectData(){
      this.$get('alarmmanagement/getcategoryandroom').then((response)=>{
        this.category_list = [{acid:'0',alarmCategoryName:'全部'}].concat(response.category);
        this.area_list = [{id:'0',divisionName:'全部'}].concat(response.division);
        this.device_type_list = [{deviceNumberSegment:'0',deviceTypeName:'全部'}].concat(response.device);
      })
    },
    initcategory(){
      this.category_list = []
      this.device_type_list = [];
      this.$get('alarmmanagement/getalarmcategorylist',[this.area]).then((response)=>{
        if(response.length > 0){
          this.category_list = [{acid:'0',alarmCategoryName:'全部'}].concat(response)
          this.category = '0'
          this.initDevice()
        }else{
          this.category = ''
          this.device_type = ''
          // this.category_list = [{acid:'0',alarmCategoryName:'全部'}]
          // this.category = '0'
          // this.device_type_list = [{deviceNumberSegment:'0',deviceTypeName:'全部'}]
          // this.device_type = '0'
        }
      })
    },
    initDevice(){
      this.device_type_list = [];
      this.$get('alarmmanagement/getdevicetypelistbyalarmcategory',[this.category]).then((response)=>{
        if(response.length > 0){
          this.device_type_list = [{deviceNumberSegment:'0',deviceTypeName:'全部'}].concat(response)
          this.device_type = '0'
        }else{
          // this.device_type_list = [{deviceNumberSegment:'0',deviceTypeName:'全部'}]
          // this.device_type = '0'
          this.device_type = ''
        }
      })
    },
    initTableData(){
      this.$get('alarmmanagement/initdata',[10,this.current_page]).then((response)=>{
        this.table_date = response.data
        for(let i in this.table_date){
          this.$set(this.table_date[i],'select',false)
        }
        this.total = parseInt(response.totalNumber)
        this.init_flag = true
      })
    },
    handleCurrentChange(page){
        this.query(page)
    },
    initDateFlag(){
      if((this.date_from && this.date_end) || (!this.date_from && !this.date_end)){
        this.data_flag = true
      }else{
        this.data_flag = false
      }
    },
    query(page){
      this.initDateFlag();
      if(this.data_flag && this.category && this.device_type){
        this.$get('alarmmanagement/getdata',[this.area, this.category, this.device_type, this.device_num? this.device_num: '0',
          this.page_size, page, this.date_from?this.date_from:'0',this.date_end?this.date_end:'0',this.status]).then((response)=>{
          this.table_date = response.data;
          for(let i in this.table_date){
            this.$set(this.table_date[i],'select',false)
          }
          this.total = parseInt(response.totalNumber);
          this.current_page = page;
          this.init_flag = false
        })
      }else{
        this.$message({
          type: 'warning',
          message: '筛选条件不完整'
        })
      }
    },
    handleAlarm(scope){
      let ids = '';
      let arr = [];
      if(scope){
        ids = scope.row.id
      }else{
        for(let i in this.table_date){
          if(this.table_date[i].select){
            arr.push(this.table_date[i].id);
            ids = arr.join(',')
          }
        }
      }
      this.$prompt('输入处理内容','处理',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
      }).then(({value})=>{
        this.$post('alarmmanagement/addalarmdealrecord',{
          alarmIds: ids,
          dealMsg: value
        }).then((response)=>{
          this.query(this.current_page)
        })
      })
    },
    checkAlarm(val){
      this.checkVisible = true
      this.$get('alarmmanagement/getalarmdealdetail',[val]).then((response)=>{
        this.check_data = response
      })
    },
    deleteAlarm(scope){
      let $this = this;
      let ids = '';
      let arr = [];
      if(scope){
        ids = scope.row.id
      }else{
        for(let i in this.table_date){
          if(this.table_date[i].select){
            arr.push(this.table_date[i].id)
            ids = arr.join(',')
          }
        }
      }
      this.$confirm('确认删除?','提示',{
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        this.$get('alarmmanagement/deletealarmmsgbyid',[ids]).then(()=>{

          if(this.current_page == Math.ceil(this.total/this.page_size)){
            this.current_page = Math.ceil((this.total - arr.length)/this.page_size)
          }
          this.query(this.current_page)
        });
      })
    },
    selectAll(){
      for(let i in this.table_date){
        this.table_date[i].select = true
      }
    },
    selectNone(){
      for(let i in this.table_date){
        this.table_date[i].select = false
      }
    },
    printTable(option){
      this.printHtml({'htmlTitle': option.title, 'selector': option.selector, 'type': 'canvas'})
    },
    print(){
      let device = this.device_num? this.device_num: '0';
      let date_from = this.date_from? this.date_from: '0';
      let date_end = this.date_end? this.date_end: '0';
      setSession('printData',[this.area, this.category, this.device_type, device,this.page_size, this.currentPage, date_from, date_end,this.status]);
      let routeData = this.$router.resolve({
        name: 'printAlarm',
        path: '/printAlarm'
      });
      window.open(routeData.href,'_blank')
    },
    download(){
      this.initDateFlag()
      if(this.data_flag){
        let a = document.createElement('a');
        this.$get('alarmmanagement/downloadalarm',[this.area,
          this.category,
          this.device_type,
          this.device_num?this.device_num:'0',
          this.date_from? this.date_from:'0',
          this.date_end? this.date_end :'0',
          this.status
        ]).then((response)=>{
          if(response.length>0) {
            a.setAttribute('href', this.rootUrl + 'alarmmanagement/downloadalarm/' + this.area + '/' + this.category + '/' + this.device_type + '/' + (this.device_num ? this.device_num : '0') + '/' + (this.date_from ? this.date_from : '0') + '/' + (this.date_end ? this.date_end : '0') + '/' + this.status);
            a.setAttribute('download', '');
            a.click();
            a.remove()
          }
        })

      }else{
        this.$message({
          type: 'warning',
          message: '请选择完整日期'
        })
      }
    },
    enlargeImg(scope){
      this.imgVisible = true;
      this.imgSrc = this.rootUrl + scope.row.alarmImageUri
    }
  }
}
</script>

<style scoped lang="scss">
  .con-wrap{
    width: 100%;
    height: 100%;
    padding-top: 10px;
    color: #ffffff;
    .select-wrap{
      margin-left: 20px;
      margin-bottom: 15px;
      &:last-child{}
      .input-cell{
        width: 200px;
      }
    }
    .download-wrap{
      margin-top: 10px;
      margin-right: 10px;
    }
    .table-wrap{
      padding: 10px;
      @media screen and (max-width: 3400px) {
        .el-table{
          height: 620px;
        }
      }
      .el-table{
        margin-bottom: 10px;
        overflow-y: auto;
        tr{
          td{
            height: 50px;
          }
        }
        .alarm-level{
          display: block;
          border-radius: 50%;
          width: 21px;
          height: 21px;
          margin: 0 auto;
          line-height: 21px;
          text-align: center;
          &.first-lv{
            background-color: #FF646A;
          }
          &.second-lv{
            background-color: #FFAA00;
          }
        }
      }
      .all-select-box{
        //display: inline-block;
      }
      .el-pagination{
        //display: inline-block;
        //margin-left: 1000px;
        float: right;
        margin-top: 20px;
      }
    }
  }
  @media screen and (min-width: 3000px) {
    .handles {
      background-color:lightblue !important;
      color: #00d851;
    }
  }
</style>
